import { createFileRoute } from "@tanstack/react-router";

import Account from "@/containers/Account";

export const Route = createFileRoute("/_app/(account)/account")({
  component: () => <Account />,
});
